module.exports = __webpack_public_path__ + "static/media/28.3dfe9412.png";